export const width=1024;export const height=1024;export default{width:width,height:height};